import { TrackedEvents, trackEvent } from 'analytics';
import type { AiModelEnum, QualityReportComposition, QualityReportLatestInspection } from 'api';
import { formatDate } from 'date';
import { useNavigate } from 'react-router-dom';
import { DataCard, ExpandableIconButton, Typography } from 'ui';
import { ImageOutlined, Insights } from 'ui/icons';

import { MaterialAiBreakdown } from '../../../breakdowns';

export const AiSurfaceAnalysisDataCard = ({
  isLoading,
  balesAnalysed,
  latestInspection,
  composition,
  aiModel,
  hasMedia,
}: {
  isLoading?: boolean;
  balesAnalysed: number;
  latestInspection: QualityReportLatestInspection;
  composition: QualityReportComposition;
  aiModel: AiModelEnum;
  hasMedia: boolean;
}) => {
  const navigate = useNavigate();

  const handleClickMedia = () => {
    trackEvent(TrackedEvents.QUALITY_REPORT_CLICK_CATEGORY_IMAGES, {
      category: 'AI Bale Surface Analysis',
    });
    navigate('media?tab=accepted');
  };

  return (
    <DataCard
      isLoading={isLoading}
      slotProps={{
        header: {
          action: hasMedia ? (
            <ExpandableIconButton icon={<ImageOutlined />} label="Show media" onClick={handleClickMedia} />
          ) : undefined,
          avatar: <Insights />,
          title: 'AI Bale Surface Analysis',
        },
      }}
    >
      <DataCard.Item colSpan={12}>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{
            paddingBottom: 2,
          }}
        >
          Visual surface analysis showing the percentage of material detected in a range of bales inspected historically
          by Safi inspectors.
        </Typography>
      </DataCard.Item>
      <DataCard.Item title="Supplier Bales Analysed" colSpan={4}>
        {balesAnalysed}
      </DataCard.Item>
      <DataCard.Item title="Latest Inspection" colSpan={8}>
        {formatDate(latestInspection)}
      </DataCard.Item>
      <DataCard.Item colSpan={12}>
        {aiModel === 'pet' ? (
          <MaterialAiBreakdown materials={composition} variant={aiModel} />
        ) : (
          <Typography>Model not supported for surface analysis.</Typography>
        )}
      </DataCard.Item>
    </DataCard>
  );
};
